import type { CSSProperties, FC, ReactNode } from 'react'

import { Reveal } from '@/components/generals/reveal'
import { HyperStar } from '@/components/landing/brand-marks'

import { CUSTOM_KEYCAPS } from '@/constants/keycaps'

const SIDE_LAYERS = [1, 0.66, 0.33]

const KeycapRing: FC = (): ReactNode => {
    const step = 360 / CUSTOM_KEYCAPS.length

    return (
        <div
            aria-hidden='true'
            className='ring [--ring-k:clamp(50px,13vw,72px)] [--ring-r:clamp(112px,30vw,170px)] md:[--ring-k:clamp(50px,6vw,80px)] md:[--ring-r:clamp(112px,15vw,196px)]'
        >
            <div className='pointer-events-none absolute inset-[14%] rounded-full bg-[radial-gradient(closest-side,rgb(255_255_255/0.045),transparent)]' />

            {CUSTOM_KEYCAPS.map((keycap, index) => {
                const Icon = keycap.icon

                return (
                    <div
                        key={keycap.name}
                        className='ring-key'
                        style={{ '--offset': `${step * index}deg` } as CSSProperties}
                    >
                        {SIDE_LAYERS.map(depth => (
                            <span
                                key={depth}
                                className='ring-side'
                                style={{ '--d': depth } as CSSProperties}
                            />
                        ))}

                        <div className='ring-top'>
                            <div className='ring-face'>
                                {Icon === 'hyper' ? <HyperStar /> : <Icon strokeWidth={1.75} />}
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
    )
}

const KeycapRingSection: FC = (): ReactNode => {
    return (
        <section id='shortcuts' className='relative px-6 pt-28 pb-24 sm:pt-40 sm:pb-36'>
            <div className='mx-auto grid max-w-[960px] items-center gap-14 md:grid-cols-[minmax(0,280px)_minmax(0,1fr)] md:gap-10'>
                <Reveal className='order-2 text-center md:order-1 md:text-left'>
                    <h2 className='text-[28px] leading-[1.2] font-medium tracking-[-0.025em] text-white sm:text-[30px]'>
                        Your shortcuts in
                        <br className='hidden md:inline' />
                        {' '}plain sight
                    </h2>

                    <p className='mx-auto mt-5 max-w-[300px] text-[15px] leading-[1.65] text-[#8e8f93] md:mx-0'>
                        Includes 14 custom keycaps and a dedicated Hyper key to make everyday actions easier to find and remember.
                    </p>
                </Reveal>

                <div className='order-1 flex justify-center md:order-2'>
                    <KeycapRing />
                </div>
            </div>
        </section>
    )
}

export default KeycapRingSection
